import Footer from 'Components/Footer/Footer'
import Navbar from 'Components/Navbar/Navbar'
import { useSessionContext } from 'Context/SessionContext'
import React from 'react'
import { Outlet,  useLocation} from 'react-router-dom'
import Navbar2 from 'Components/Navbar/Navbar2'

const PublicLayout = () => {

     const location = useLocation();
     const path = location.pathname;
     const excludedPaths = [
    '/',
    '/faqs',
    '/support',
    '/terms-and-conditions',
    '/end-user-license-agreement',
    '/return-refund-policy',
    '/privacy-policy',
    '/others',
    '/search',
    '/thank-you-for-your-order',

  ];

  const isMerchantRoute = path.startsWith('/merchant');
  const isSecurityRoute = path.startsWith('/sec');
  const isOrderRoute = path.startsWith('/p');
  const firstSegment = path.split('/')[1];
  const useNavbar2 =
    firstSegment && 
    !excludedPaths.includes(path) && 
    !isMerchantRoute && !isSecurityRoute && !isOrderRoute &&
    path !== '/'; 

    return (
    <React.Fragment>
      {useNavbar2 ? <Navbar2 /> : <Navbar />}
      <div className="content">
        <Outlet />
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default PublicLayout;

//     return <React.Fragment>
//         <Navbar/>
//         <div className="content">
//         <Outlet/>
//         </div>
//         <Footer/>
//     </React.Fragment>
// }

// export default PublicLayout